import { Box } from '@mui/material';
import useKeywordsStore from 'src/stores/keywords';

import useIsMobileSize from 'src/hooks/useIsMobileSize';

import BottomSheetHeader from '../BottomSheetHeader';
import { getKeywordsFilter } from '../FeedFilter/utils';
import FilterItem from '../FeedFilter/Components/FilterItem';

export default function KeywordsSheet() {
    const { keywords } = useKeywordsStore(({ keywords }) => ({ keywords }));

    const isMobile = useIsMobileSize();

    const item = getKeywordsFilter(keywords, isMobile);

    return (
        <Box
            px={1}
            sx={{
                maxHeight: '70vh',
                overflow: 'auto',
                '&::-webkit-scrollbar': {
                    width: '6px',
                },
                '&::-webkit-scrollbar-track': {
                    background: '#f1f1f1',
                    borderRadius: '3px',
                },
                '&::-webkit-scrollbar-thumb': {
                    background: '#c1c1c1',
                    borderRadius: '3px',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                    background: '#a8a8a8',
                },
            }}
        >
            <BottomSheetHeader title="Ключевые слова" />
            {
                <FilterItem
                    key={item.title}
                    {...item}
                />
            }
        </Box>
    );
}
